<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PORTL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="customCodeSelectPortal"
              v-model="selectedPortalId"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              :option-list="portalList"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="this.$options.name"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              @select-changed="onChangeBizCodes"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BASIC_AUTH')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="basicAuthYn"
              :selected="selectedValues.COD_BSIC_AUTH_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="condType"
              :selected="selectedValues.COD_USER_GRP_SRCH_COND"
              codeId="COD_USER_GRP_SRCH_COND"
              :initialSelectedIndex="0"
              :defaultOption="'all'"
              @loaded="onCondTypeLoaded"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="condContent"
              default
              value
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00003'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      </div>
      <div class="mrB30" />
      <div class="mrB10" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-s-grid
            ref="grdList"
            :headers="gridColumns"
            :data-source="dsData"
            :options="options"
            :showRowsPerPageControl="false"
            :initialRowsPerPage="10"
            @grid:selected="onSelectGrid"
          />
        </div>
        <div class="emptybox" />
        <div class="inbox">
          <div class="mrB45" />
          <sui-page-tab-box-type
            :tabItems="tabItems"
            :defaultTabIndex="defaultTabIndex"
            :setCurrentTabComponent="onSetCurrentTabComponent"
            @change-tab-idx="onChangeTabIdx"
          >
            <container
              :is="currentTabComponent"
              ref="tabPage"
              :pageId="this.$options.name"
              :selectedGridRowData="selectedGridRowData"
              :selectedPageId="selectedPageId"
              :isDataNull="isNullData"
              @onClearSelectionMainGrid="onClearSelectionMainGrid"
              @onSearchClick="onSearch"
              @onPopupCall="onPopupCall"
              @page-deactivate="handleChildDeactivated" 
              @page-activate="handleChildActivated"
            />
          </sui-page-tab-box-type>
        </div>
      </div>

      <sui-popup
        v-model="isShownPopupRole"
        :title="$t('MSG_TIT_ROLE_USER_GROUP_REG')"
      >
        <p01
          :pageId="$options.name"
          :userGroupId="userGroupId"
          @onClickCancel="onClickCancel"
          @onRowReSelect="onRowReSelect"
        />
      </sui-popup>

      <sui-popup
        v-model="isShownPopupUser"
        :title="$t('MSG_TIT_USR_USR_GROUP_REG')"
      >
        <p02
          :pageId="$options.name"
          :userGroupId="userGroupId"
          @onClickCancel="onClickCancel"
          @onRowReSelect="onRowReSelect"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMA_00003_T01';
import tab02 from './components/PGE_CMA_00003_T02';
import tab03 from './components/PGE_CMA_00003_T03';
import p01 from './components/PGE_CMA_00003_P01';
import p02 from './components/PGE_CMA_00003_P02';
import {urDataSet} from 'uidev-component/index.js';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

// import - libraries (node modules)
// import - local files (js, vue, ...)
export default {
  name: 'PGE_CMA_00003', // eslint-disable-line vue/name-property-casing
  components: {
    urDataGrid:urDataGrid,
    tab01,
    tab02,
    tab03,
    p01,
    p02,
  },
  extends: BasePage,
  data() {
    return {
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_USER_GROUP'),
          component: 'tab01', // pageID
        },
        {
          tabTitle: this.$t('MSG_TXT_USR'),
          component: 'tab02',
        },
        {
          tabTitle: this.$t('MSG_TXT_ROLE'),
          component: 'tab03',
        },
      ],
      isNullData: false,
      oldRowIndex: -1,
      searchFieldOldText: '',
      condTypeKey: '',
      currentTabComponent: null,
      tabIndex: 0,
      pageTitle: this.$t('MSG_TIT_USER_GRP_MGT'), // eslint-disable-line vue/name-property-casing,
      pageLocations: ['Common', 'CMA', this.$t('MSG_TIT_USER_GRP_MGT')],
      isPageHeaderShow: true,
      isMyFavorites: false,
      showCheckIdModal: false,
      selectedPageId: '',
      condContent: '',
      userGroupId: '',
      selectedGridRowData: {},
      isShownPopupRole: false,
      isShownPopupUser: false,
      selected3rdBizCode: '',
      selectedBizCode: [],
      selectedValues: {
        COD_USER_GRP_SRCH_COND: { key: '', label: '' },
        COD_BSIC_AUTH_YN: { key: '', label: '' },
      },
      selectedPortalId: '',
      localdata: [],
      dsData: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
      },      
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  created() {
    this.portalList = [];
    this.gridColumns = [
      {
        text: this.$t('MSG_TXT_USER_GRP_ID'),
        value: 'userGroupId',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_PORTL'),
        value: 'portalId',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_USER_GRP_NAME'),
        value: 'userGroupName',
      },
      {
        text: this.$t('MSG_TXT_TASK_TYPE'),
        value: 'taskName',
        width: 300,
      },
    ];
  },
  mounted() {
    this.loadPortalList();
    // this.dsData.$on(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
    // if (this.dsData) {
    //   this.dsData.$off(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    // }
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    loadPortalList() {
      http.request(this.contextPageId, 'DTS_CMP_00004', {
      }).then(res => {
        this.portalList = [];
        if (res.data.length > 0) {
          utils.forEach(res.data, obj => {
            const portalInfo = {
              key: obj.portalId,
              label: obj.portalName,
            };
            this.portalList.push(portalInfo);
          });
          this.selectedPortalId = this.$store.getters.userInfo.portalId;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    onClose() {
      console.log('onConfirm');
    },
    onClearSelectionMainGrid() {
      this.$refs.grdList.resetSelect();
      this.selectedGridRowData = {};
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    changeTabIndex() {
      const idx = this.tabIndex + 1;
      this.$refs.tab.changeIdx(idx % 3);
    },
    onCondTypeLoaded(optionsList) {
      this.condTypeKey = optionsList[0].key;
    },
    onReset() {
      this.$refs.condType.reset();
      this.$refs.taskIdSelect.reset();
      this.$refs.basicAuthYn.reset();
      this.$refs.customCodeSelectPortal.reset();
      // this.selectedValues.COD_USER_GRP_SRCH_COND.key = this.condTypeKey;
      this.condContent = '';
    },
    onSearch() {
      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }
      const condTypeCode = this.selectedValues.COD_USER_GRP_SRCH_COND.key;
      const basicAuthYn = this.selectedValues.COD_BSIC_AUTH_YN.key === 'ALL' ? '' : this.selectedValues.COD_BSIC_AUTH_YN.key;
      const portalId = this.selectedPortalId === 'ALL' ? '' : this.selectedPortalId;
      const queryParams = {
        taskId: taskId || '',
        portalId: portalId,
        basicAuthYn: basicAuthYn,
        searchCond: condTypeCode || '',
        searchWord: utils.trim(this.condContent) || '',
      };

      http.request(this.$options.name, 'DTS_CMA_00008', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.$refs.grdList.resetSelect();
            this.dsData.setData(res.data);
            this.oldRowIndex = 0;
            this.isNullData = false;
          } else {
            this.$refs.grdList.resetSelect();
            this.dsData.setData([]);
            this.selectedGridRowData = {};
            this.selectedPageId = '';
            this.userGroupId = '';
            this.isNullData = true;
            this.$refs.tabPage.initData();
            this.oldRowIndex = -1;
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onKeyUpInput() {
      const searchFieldNewText = this.condContent;
      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.condContent = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onSelectGrid(row) {
      if (row) {
        this.selectedGridRowData = row;
        // this.selectedPageId = this.selectedGridRowData ? this.selectedGridRowData.pageId : '';
        // this.userGroupId = this.selectedGridRowData ? this.selectedGridRowData.userGroupId : '';
        //sonarcube codesmell 대응
        this.selectedPageId = this.selectedGridRowData.pageId;
        this.userGroupId = this.selectedGridRowData.userGroupId;
      } else {
        this.selectedGridRowData = {};
        this.selectedPageId = '';
        this.userGroupId = '';
      }
    },
    onClickCancel(event) {
      this[event] = false;
    },
    onPopupCall(event) {
      this[event] = true;
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onRowReSelect() {
      this.selectedGridRowData = this.dsData.getSelected()[0];
      this.selectedPageId = this.selectedGridRowData ? this.selectedGridRowData.pageId : '';
      this.userGroupId = this.selectedGridRowData ? this.selectedGridRowData.userGroupId : '';
    },
  },
};
</script>
<style scoped>
</style>
